import { useField } from 'formik'
import { BrandPlanTactic } from 'types'
import { CheckboxGroup } from 'components/CheckboxGroup/CheckboxGroup'
import Styles from './CrosspostTactics.module.scss'
import cx from 'classnames'
import { TacticCheckbox } from './TacticCheckbox'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

interface VideoCrosspostTacticsProps {
  className?: string
  applyRedesign?: boolean
}

export const VideoCrosspostTactics = ({ className, applyRedesign = false }: VideoCrosspostTacticsProps = {}) => {
  const isOnboardingRedesign = applyRedesign
  const [{ value }, , { setValue }] = useField<BrandPlanTactic[]>('tactics')

  return (
    <CheckboxGroup
      value={value}
      onChange={(value) => setValue(value as BrandPlanTactic[])}
      className={cx(Styles.group, className, { [Styles.applyRedesign]: isOnboardingRedesign })}
      aria-label="Video crosspost platforms"
    >
      <TacticCheckbox
        provider={ExternalIntegrationEnum.Instagram}
        label="Instagram Reels"
        applyRedesign={applyRedesign}
        value={BrandPlanTactic.InstagramReel}
        isDisabled={!value.includes(BrandPlanTactic.InstagramReel)}
        onCancel={() => setValue(value)}
      />
      <TacticCheckbox
        provider={ExternalIntegrationEnum.YouTube}
        label="YouTube Shorts"
        applyRedesign={applyRedesign}
        value={BrandPlanTactic.YouTube}
        isDisabled={!value.includes(BrandPlanTactic.YouTube)}
        onCancel={() => setValue(value)}
      />
      <TacticCheckbox
        provider={ExternalIntegrationEnum.TikTok}
        label="TikTok Posts"
        applyRedesign={applyRedesign}
        value={BrandPlanTactic.TikTok}
        isDisabled={!value.includes(BrandPlanTactic.TikTok)}
        onCancel={() => setValue(value)}
      />
    </CheckboxGroup>
  )
}
